import React, { useEffect, useRef } from 'react';
import { Box } from '@mui/material';

export default function VendorDelaysCard() {
  const chartRef = useRef(null);
  const initialized = useRef(false);

  useEffect(() => {
    if (initialized.current) return;
    initialized.current = true;

    if (chartRef.current && typeof window.opsDelayChart !== 'undefined') {
      window.opsDelayChart.canvas = chartRef.current;
      window.opsDelayChart.ctx = chartRef.current.getContext('2d');
    }
  }, []);

  return (
    <Box className="card" style={{ minHeight: '300px' }}>
      <div className="card-head">
        <h3 className="card-title">Vendor Delays (avg days)</h3>
        <span className="click-tag">Click bars for vendor detail</span>
      </div>
      <div className="chart-wrap" style={{ height: '240px' }}>
        <canvas id="opsDelayChart" ref={chartRef}></canvas>
      </div>
    </Box>
  );
}
